//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "WaterDeficit",
  data() {
    return {
      form: {
        sex: "0",
        age: "",
        weight: "",
        na: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "1", name: "女" },
        { value: "2", name: "男" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let multiple = 1
      let sumWater = ''
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        if(form.sex && form.age<=60) {
          multiple = 0.6
        }else if((form.sex && form.age >60) ||(!form.sex && form.age <=60) ) {
          multiple = 0.5
        }else if(!form.sex&& form.age >60) {
          multiple = 0.45
        }
        sumWater = multiple * form.weight
        let result = (sumWater*(1- 140/form.na)).toFixed(2)
        self.hasScore = true;
        return result;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/WaterDeficit.vue